import React from 'react';

export function Plus({ size = 55 }): JSX.Element {
  return (
    <svg viewBox='0 0 57.75 57.75' width={size} height={size}>
      <path fill='none' stroke='#3db384' strokeWidth={2.11} d='M28.88 1v55.75M1 28.88h55.75' />
    </svg>
  );
}
